import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { FilterX } from "lucide-react";

export function inDateRange(iso, from, to) {
  if (!from && !to) return true;
  const d = (iso || "").slice(0, 10);
  if (!d) return false;
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}

export function FilterSelect({ value, onChange, options, placeholder, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-40" data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__all__">{placeholder} (All)</SelectItem>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default function FilterBar({ from, to, onFrom, onTo, onClear, children, extra }) {
  return (
    <div className="flex flex-wrap items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-2" data-testid="advanced-filter-bar">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Filters</span>
      <Input type="date" value={from} onChange={(e) => onFrom(e.target.value)} className="w-36" data-testid="filter-date-from" />
      <span className="text-slate-400 text-xs">to</span>
      <Input type="date" value={to} onChange={(e) => onTo(e.target.value)} className="w-36" data-testid="filter-date-to" />
      {children}
      {extra}
      <Button variant="ghost" size="sm" onClick={onClear} className="text-slate-500" data-testid="clear-filters-btn">
        <FilterX className="w-3.5 h-3.5 mr-1" />Clear
      </Button>
    </div>
  );
}
